module.exports = __webpack_public_path__ + "img/img_shiyong.4d8261b5.png";